export const WorkflowId = {
    POST_SESSION_WORKFLOW_ID: 'PostSessionWorkflow',
};
